import Vue from "vue";
import Vuex from "vuex";
import emailSending from "./store/emailSending";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    emailSending
  }
});
